<template>
    <div class="forget" :style="{height:`${contentHeight}rem`}">
        <turnBack :content='content' :url='url' style="color:#FFF" />
        <img src="@/assets/img/login/icon_pwd_forget.png" alt="logo" style="width:100%;position: absolute;top: 0px;left: 0px;">
        <div style="margin-top:14rem">
            <el-form class="loginForm" ref="form" :model="form" style="margin:2rem 3rem">
                <el-form-item >
                    <img src="@/assets/img/login/icon_login_user.png" alt="logo" style="width:1.5rem;height:1.6rem;margin-right:10px">
                    <el-input v-model="loginForm.phone" placeholder="请输入你的手机号码"></el-input>
                </el-form-item>
                <el-form-item >
                    <div style="background:#d9e0eb">
                        <img src="@/assets/img/login/icon_login_code.png" alt="logo" style="width:1.5rem;height:1.6rem;margin-right:10px">
                    </div>
                    <el-input v-model="loginForm.phone" placeholder="请输入验证码"></el-input>
                </el-form-item>
                <el-form-item >
                    <img src="@/assets/img/login/icon_login_pwd.png" alt="logo" style="width:1.5rem;height:1.6rem;margin-right:10px">
                    <el-input v-model="loginForm.password" placeholder="输入新密码"></el-input>
                </el-form-item>
                <el-form-item >
                    <img src="@/assets/img/login/icon_login_pwd.png" alt="logo" style="width:1.5rem;height:1.6rem;margin-right:10px">
                    <el-input v-model="loginForm.password" placeholder="再次输入新密码"></el-input>
                </el-form-item>
                <el-button type="primary" @click="onLogin" style="background:#00999d;width:100%;border:1px solid #00999d">修改密码</el-button>
            </el-form>
        </div>
    </div>
</template>
<script>
import turnBack from '@/components/turnBack'

export default {
    components:{
        turnBack,
    },
    data(){
        return {
            contentHeight:0,
            content:'',
            url:'/',
            loginForm:{
                password: "",
                phone: "",
            }
        }
    },
    mounted(){
        this.contentHeight = document.documentElement.clientHeight/16
    },
    methods:{
        onLogin(){

        },
        GotoPath(url){
            this.$router.push({ path: url })
        }
    }
}
</script>
<style lang="less" >
.forget{
    .loginForm{
        .el-form-item{
            border-bottom: 1px solid #FFF;
        }
        .el-form-item__content{
            display: flex;
            align-items: center;
        }
        .el-input__inner{
            background: transparent;
            border: 0px;
        }
    }
}
</style>